import axios from "axios";

const Api = axios.create({
  baseURL: process.env.VUE_APP_BASE_API_URL,
  headers: {
    "content-type": "application/json",
    accept: "application/json"
  }
});

export default {
  health: (config = {}) => Api.get("/api/health", config),
  // Deprecated: prefer health() for frontend polling.
  status: () => Api.get("/api/travelstart/flights/status"),
  countries: body => Api.get("/api/travelstart/flights/countries", body),
  search: body => Api.post("/api/travelstart/flights/search", body),
  priceCheck: body => {
    body.data = null;

    return Api.post("/api/travelstart/flights/priceCheck", body);
  },
  paymentMethods: body =>
    Api.post("api/travelstart/flights/paymentMethods", body),
  book: body => Api.post("/api/travelstart/flights/book", body),
  checkRedirectStatus: id =>
    Api.get(`/api/travelstart/flights/redirectCheck/${id}`),
  authorizeBooking: body =>
    Api.post("api/travelstart/flights/authorizeBooking", body),
  pnp: body => Api.post("/api/flights/pnp", body),
  sendConfirmationMail: body =>
    Api.post("/api/travelstart/flights/sendConfirmationMail", body),
  recordStoreReference: body =>
    Api.post("/api/travelstart/flights/recordStoreReference", body),
  radixxAirRules: () => Api.get("/api/travelstart/flights/radixxAirRules"),
  logSpecialFareWarning: body =>
    Api.post("/api/logs/special-fare-warning", body)
};
